var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatComputerPecheur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.45,
    height: 188.73,
    viewBox: "0 0 323.45 188.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOAT_ORDINATEUR",
    "data-name": "BOAT ORDINATEUR",
    transform: "translate(-377 -73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT",
    "data-name": "FOND TRANSPARENT",
    width: 323.45,
    height: 188.73,
    transform: "translate(377 73)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "BOAT_13",
    "data-name": "BOAT 13",
    transform: "translate(373.004 -123.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    d: "M108.993,157.439S34.767,261.716,11.262,273.368s40.231,13.978,60.614,7.283S108.993,157.439,108.993,157.439Z",
    transform: "translate(16.543 54.691)",
    fill: "#66bdcc",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(3.996 155.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393",
    transform: "translate(7.625 45.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7389",
    "data-name": "Path 7389",
    d: "M5.636,286.128,118.333,157,310.473,269.556l.588-.44-192.95-113.03-.273.312L4.868,285.835Z",
    transform: "translate(-4.868 -156.087)",
    fill: "#42647a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(120.588 46.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7390",
    "data-name": "Path 7390",
    d: "M75.789,252.981l.782-.368L18.562,156.142l-.781.368Z",
    transform: "translate(-17.781 -156.142)",
    fill: "#42647a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7391",
    "data-name": "Path 7391",
    d: "M16.15,247.286h0a2.938,2.938,0,0,0,3.1-2.749V171.483a2.939,2.939,0,0,0-3.1-2.757h0a2.945,2.945,0,0,0-3.1,2.757v73.054A2.944,2.944,0,0,0,16.15,247.286Z",
    transform: "translate(66.173 -69.144)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(41.007 103.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7392",
    "data-name": "Path 7392",
    d: "M72.6,232.019l.84-.248c-.219-.59-23.016-61.675-23.016-61.675l-.3-.808L8.684,230.123l.761.4,40.441-59.377C52.581,178.366,72.395,231.475,72.6,232.019Z",
    transform: "translate(-8.684 -169.287)",
    fill: "#42647a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(81.906 50.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7393",
    "data-name": "Path 7393",
    d: "M14.2,254.3,53.41,156.978l-.836-.264L13.359,254.035Z",
    transform: "translate(-13.36 -156.714)",
    fill: "#42647a"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1404",
    "data-name": "Rectangle 1404",
    width: 9.204,
    height: 150.076,
    rx: 0.265,
    transform: "translate(126.141 194.383) rotate(180)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(0 92.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7394",
    "data-name": "Path 7394",
    d: "M181.664,244.04l-15.877-29.4a3.127,3.127,0,0,1-.385-1.5v-20a3.239,3.239,0,0,1,.857-2.167l7.366-8.186a3.234,3.234,0,0,0,.857-2.159v-9.4a3.72,3.72,0,0,0-3.989-3.464L55.109,170a3.828,3.828,0,0,0-3.683,2.571l-4.2,14.1a3.4,3.4,0,0,1-.437.909C32.26,208.9,35.095,204.95,32.111,210.3L14.773,245.9c.131,1.849,21.852,5.258,23.943,5.227l139.5-2.12C181.052,248.956,182.889,246.315,181.664,244.04Z",
    transform: "translate(79.499 -167.77)",
    fill: "#f2d9bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8731",
    "data-name": "Path 8731",
    d: "M181.664,244.04l-15.877-29.4a3.127,3.127,0,0,1-.385-1.5v-20a3.239,3.239,0,0,1,.857-2.167l7.366-8.186a3.234,3.234,0,0,0,.857-2.159v-9.4a3.72,3.72,0,0,0-3.989-3.464l-1.23,7.542c-1.741.031,1.677,2.38,1.23,3.871l-9.112,12.8a3.4,3.4,0,0,1-.437.909c-14.53,21.32.676,14.9-2.307,20.255l17.655,34.138c.131,1.849-25.513,9.185-23.422,9.154L178.218,249C181.052,248.956,182.889,246.315,181.664,244.04Z",
    transform: "translate(79.499 -167.77)",
    fill: "#ffe8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7396",
    "data-name": "Path 7396",
    d: "M25.356,170l116.285-2.229a3.739,3.739,0,0,1,4.02,3.464v9.4l-127.04,2,3.024-10.058A3.856,3.856,0,0,1,25.356,170Z",
    transform: "translate(109.305 -168.77)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7397",
    "data-name": "Path 7397",
    d: "M19.507,171.262l125.96-1.856v.155a3.234,3.234,0,0,1-.857,2.159l-.577.637L18.518,174.579Z",
    transform: "translate(108.515 -156.699)",
    fill: "#b91b00",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(223.292 26.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1405",
    "data-name": "Rectangle 1405",
    width: 17.704,
    height: 20.237,
    rx: 0.247,
    transform: "translate(17.704 20.237) rotate(180)",
    fill: "#66bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7398",
    "data-name": "Path 7398",
    d: "M45.653,190.891V174.48a2.043,2.043,0,0,0-2.161-1.911H30.108a2.419,2.419,0,0,0-.577.1,2.072,2.072,0,0,1,2.073-1.546H45a2.05,2.05,0,0,1,2.161,1.918v16.4a1.946,1.946,0,0,1-1.592,1.81A1.316,1.316,0,0,0,45.653,190.891Z",
    transform: "translate(-29.45 -171.125)",
    fill: "#3d717a",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(194.19 26.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1406",
    "data-name": "Rectangle 1406",
    width: 17.704,
    height: 20.237,
    rx: 0.247,
    transform: "translate(17.704 20.237) rotate(180)",
    fill: "#66bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7401",
    "data-name": "Path 7401",
    d: "M42.319,190.891V174.48a2.041,2.041,0,0,0-2.152-1.911H26.774a2.276,2.276,0,0,0-.569.1,2.058,2.058,0,0,1,2.073-1.546H41.662a2.05,2.05,0,0,1,2.161,1.918v16.4a1.946,1.946,0,0,1-1.583,1.81A1.705,1.705,0,0,0,42.319,190.891Z",
    transform: "translate(-26.118 -171.125)",
    fill: "#3d717a",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "translate(165.09 26.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 17.704,
    height: 20.237,
    rx: 0.247,
    transform: "translate(17.704 20.237) rotate(180)",
    fill: "#66bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7404",
    "data-name": "Path 7404",
    d: "M39,190.891V174.48a2.049,2.049,0,0,0-2.161-1.911H23.455a2.275,2.275,0,0,0-.577.1,2.072,2.072,0,0,1,2.073-1.546H38.344a2.041,2.041,0,0,1,2.152,1.918v16.4a1.937,1.937,0,0,1-1.583,1.81A1.72,1.72,0,0,0,39,190.891Z",
    transform: "translate(-22.794 -171.125)",
    fill: "#3d717a",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404",
    transform: "translate(135.989 26.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 17.704,
    height: 20.237,
    rx: 0.247,
    transform: "translate(17.704 20.237) rotate(180)",
    fill: "#66bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7407",
    "data-name": "Path 7407",
    d: "M35.673,190.891V174.48a2.041,2.041,0,0,0-2.152-1.911H20.128a2.419,2.419,0,0,0-.577.1,2.072,2.072,0,0,1,2.073-1.546H35.017a2.05,2.05,0,0,1,2.161,1.918v16.4a1.946,1.946,0,0,1-1.583,1.81A1.705,1.705,0,0,0,35.673,190.891Z",
    transform: "translate(-19.471 -171.125)",
    fill: "#3d717a",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(0 56.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7411",
    "data-name": "Path 7411",
    d: "M316.038,175.542c6.141-2.2,12.527,2.54,11.241,8.271-7.077,31.673-36.295,71.757-62.162,71.757H28.373c-26.751,0-22.736-31.44-24.074-44.8a56.263,56.263,0,0,1-.087-10.749c.542-5.941,6.228-10.469,12.991-10.469h195.3C267.242,189.553,299.828,181.344,316.038,175.542Z",
    transform: "translate(-3.996 -174.993)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8730",
    "data-name": "Path 8730",
    d: "M316.038,175.542c6.141-2.2,12.527,2.54,11.241,8.271-7.077,31.673-36.295,71.757-62.162,71.757,72.737-84.276-68.622-40.3-52.61-66.017C236.022,191.225,275.934,188.065,316.038,175.542Z",
    transform: "translate(-3.996 -174.993)",
    fill: "#537991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    "data-name": "Path 7412",
    d: "M4.021,202.043h0c.542-5.942,6.228-10.477,12.991-10.477h195.3c54.735,0,87.321-8.2,103.531-14.011a30.876,30.876,0,0,0,4.75-2.54c4.216.769,7.436,4.427,6.491,8.652-.035.155-.079.318-.114.474-17.548,6.307-51.8,17.9-114.658,17.9Z",
    transform: "translate(-3.805 -174.847)",
    fill: "#335469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M212.316,200.03H4.021v-.008c.542-5.941,6.228-10.469,12.991-10.469h195.3c54.735,0,87.321-8.209,103.531-14.011,5.494-1.965,11.136,1.623,11.355,6.5C309.723,188.325,275.44,200.03,212.316,200.03Z",
    transform: "translate(-3.805 -174.993)",
    fill: "#ffe8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M315.847,177.18c-16.21,5.8-48.8,14-103.531,14H17.012c-6.123,0-11.32,3.736-12.658,8.846H4.021v-.008c.542-5.941,6.228-10.469,12.991-10.469h195.3c54.735,0,87.321-8.209,103.531-14.011,5.494-1.965,11.136,1.623,11.355,6.5l-.28.1C325.723,178.1,320.737,175.425,315.847,177.18Z",
    transform: "translate(-3.805 -175.993)",
    fill: "#f1bfa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    d: "M316.761,179.466c-1.627,3.13-3.394,6.221-5.275,9.227-17.9,6.928-37.869,10.71-63.343,10.71H4.559c-.219-2.12-.367-4.241-.464-6.291H248.142C276.328,193.112,297.533,188.266,316.761,179.466Z",
    transform: "translate(-3.232 -144.728)",
    fill: "#335469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7416",
    "data-name": "Path 7416",
    d: "M318.3,179.093c-1.513,3.107-3.167,6.19-4.951,9.2-18.344,7.363-38.805,11.37-65.119,11.37H4.434c-.175-2.144-.271-4.264-.35-6.291H248.228C277.122,193.376,298.694,188.32,318.3,179.093Z",
    transform: "translate(-3.317 -147.252)",
    fill: "#ffe8cc"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1409",
    "data-name": "Rectangle 1409",
    width: 9.204,
    height: 2.423,
    transform: "translate(126.141 50.724) rotate(180)",
    fill: "#ffe8cc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7420",
    "data-name": "Path 7420",
    d: "M14.615,177.309a2.817,2.817,0,0,1-2.966,2.633,2.652,2.652,0,1,1,0-5.266A2.817,2.817,0,0,1,14.615,177.309Z",
    transform: "translate(36.319 127.022)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M17.2,173.08a2.817,2.817,0,0,1-2.966,2.633,2.652,2.652,0,1,1,0-5.266A2.811,2.811,0,0,1,17.2,173.08Z",
    transform: "translate(56.355 98.405)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M19.353,168.914a2.811,2.811,0,0,1-2.966,2.633,2.652,2.652,0,1,1,0-5.266A2.811,2.811,0,0,1,19.353,168.914Z",
    transform: "translate(73.028 70.215)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7425",
    "data-name": "Path 7425",
    d: "M21.678,170.314a2.816,2.816,0,0,1-2.966,2.633,2.652,2.652,0,1,1,0-5.266A2.816,2.816,0,0,1,21.678,170.314Z",
    transform: "translate(91.042 79.689)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7426",
    "data-name": "Path 7426",
    d: "M21.138,174.234a2.811,2.811,0,0,1-2.966,2.633,2.655,2.655,0,1,1,0-5.274A2.812,2.812,0,0,1,21.138,174.234Z",
    transform: "translate(86.858 106.16)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7427",
    "data-name": "Path 7427",
    d: "M20.143,177.9a2.806,2.806,0,0,1-2.966,2.633,2.652,2.652,0,1,1,0-5.266A2.811,2.811,0,0,1,20.143,177.9Z",
    transform: "translate(79.149 131.041)",
    fill: "#42647a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatComputerPecheur);
export default __webpack_public_path__ + "static/media/boat-computer-pecheur.16c3f4cf.svg";
export { ForwardRef as ReactComponent };